import { Button } from '@material-ui/core'
import AgDetail from './AgDetail'

export const SelectAGButton = ({
  setOpenDetail,
  openDetail,
  coproprietaire_id,
  copro_id,
  record,
}) => {
  const handleClick = () => {
    if (record) {
      setOpenDetail(true)
    }
  }
  const isDisabled = new Date(record.dateprevisionnelle) < new Date()

  return (
    <div>
      <Button
        color="primary"
        size="large"
        variant="contained"
        label="Voir les resolutions"
        onClick={handleClick}
        disabled={isDisabled}
      >
        Voir les resolutions
      </Button>
      <AgDetail
        setOpenDetail={setOpenDetail}
        openDetail={openDetail}
        record={record}
        coproprietaire_id={coproprietaire_id}
        copro_id={copro_id}
      />
    </div>
  )
}
export default SelectAGButton
